/**
 * Helper to create a wrapper component with an optional
 * options object
 *
 * Using to create a wrapper:
 * ```ts
 * export default buildWrapper((options = {}) => {
 *   return Wrapper({})
 * })
 * ```
 *
 * Using the wrapper:
 * ```ts
 * Wrapper(WrappedComponent) // no options
 * Wrapper(options)(WrappedComponent) // with options
 * ```
 */
export default (generateWrapper: (options?: Record<string, any>) => any) =>
  (options: any): any => {
    if (typeof options === 'object') {
      return generateWrapper(options)
    } else {
      return generateWrapper()(options)
    }
  }
